import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postResolveLTSupportTicket = createApi(`PostResolveLTTicketSummarySlice`,"POST");

const PostResolveLTTicketSummarySlice = createSlice({
  name: 'PostResolveLTTicketSummarySlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postResolveLTSupportTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postResolveLTSupportTicket.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postResolveLTSupportTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostResolveLTTicketSummarySlice.reducer;